import { render, staticRenderFns } from "./modifypayword.vue?vue&type=template&id=6354ab26&scoped=true"
import script from "./modifypayword.vue?vue&type=script&lang=js"
export * from "./modifypayword.vue?vue&type=script&lang=js"
import style0 from "./modifypayword.vue?vue&type=style&index=0&id=6354ab26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6354ab26",
  null
  
)

export default component.exports